/**
 * Usonian CSS > Elements > Heading
 */

import { css } from 'styled-components';
import { globals } from 'shared/styles/settings';

export default css`
  h1 {
    font-family: Nunito, system, BlinkMacSystemFont, sans-serif;
    font-size: ${globals.fontSizeLargest};
    font-weight: ${globals.fontWeightHeavy};
    letter-spacing: -0.5px;
    line-height: 1.2;
    margin-bottom: 0.5rem;
  }

  h2 {
    font-family: Nunito, system, BlinkMacSystemFont, sans-serif;
    font-size: ${globals.fontSizeLarger};
    line-height: 1.2;
    margin-bottom: 0.5rem;
  }

  h3 {
    font-size: ${globals.fontSizeLarge};
    font-weight: ${globals.fontWeightHeavier};
    line-height: 1.2;
    margin-bottom: 0.5rem;
  }

  h4 {
    font-family: Nunito, system, BlinkMacSystemFont, sans-serif;
    font-size: ${globals.fontSizeLarge};
    font-weight: 200;
    line-height: 1.2;
    margin-bottom: 0;
    text-transform: uppercase;
  }

  h5 {
    font-size: ${globals.fontSizeSmall};
    line-height: 1.2;
  }

  h6 {
    font-family: Nunito, system, BlinkMacSystemFont, sans-serif;
    font-size: ${globals.fontSizeSmall};
    font-weight: 400;
    line-height: 1.2;
    margin-bottom: 0;
    text-transform: uppercase;
  }
`;
